import React from "react";
import { OBJECT_RESIZE_HANDLES } from "./objectTransformMath";
import "./ObjectTransformChrome.css";

/**
 * Shared Editor object BB + resize/rotate chrome.
 * Used by CanvasEditor and tool-prep previews — one visual source of truth.
 */
const ObjectTransformChrome = ({
  visible = true,
  mode = "selected", // "selected" | "hover"
  width,
  height,
  left,
  top,
  rotation = 0,
  flipX = 1,
  flipY = 1,
  isResizing = false,
  isRotating = false,
  isDragging = false,
  showRotate = true,
  onResizeMouseDown,
  onRotateMouseDown,
  onBoxMouseDown,
  className = "",
  style = null,
}) => {
  if (!visible || !(width > 0) || !(height > 0)) return null;

  const isHover = mode === "hover";
  const transforming = isRotating || isDragging || isResizing;

  return (
    <div
      className={[
        "object-transform-chrome",
        isHover ? "object-transform-chrome--hover" : "",
        transforming ? "is-transforming" : "",
        onBoxMouseDown ? "object-transform-chrome--interactive" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left: `${left}px`,
        top: `${top}px`,
        transform: `rotate(${rotation}deg) scale(${flipX}, ${flipY})`,
        transformOrigin: "center center",
        ...style,
      }}
    >
      {isHover ? (
        <div className="object-bounding-box object-bounding-box--hover" />
      ) : (
        <>
          {showRotate && !isResizing && (
            <>
              <div
                className="object-rotate-handle"
                onMouseDown={onRotateMouseDown}
                title={`Rotate: ${Math.round(rotation)}°`}
              >
                <div className="rotate-handle-line" />
                <div className="rotate-handle-circle">↻</div>
              </div>
              {isRotating && (
                <div className="rotation-angle-display">
                  {Math.round(rotation)}°
                </div>
              )}
            </>
          )}

          {!isRotating && (
            <>
              {onBoxMouseDown ? (
                <div
                  className="object-transform-chrome__move-hit"
                  onMouseDown={onBoxMouseDown}
                />
              ) : null}
              {OBJECT_RESIZE_HANDLES.map((handle) => (
                <div
                  key={handle}
                  className={`object-resize-handle ${
                    handle.startsWith("corner")
                      ? "corner-handle"
                      : "edge-handle"
                  } ${handle}`}
                  onMouseDown={
                    onResizeMouseDown
                      ? (e) => onResizeMouseDown(e, handle)
                      : undefined
                  }
                />
              ))}
              <div className="object-bounding-box" />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ObjectTransformChrome;
